<template>
  <SelectTableDialog
    :title="title"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    width="1200px"
    :columnWidth="100"
    @close="close"
    @confirm="confirm"
    :extraData="extraData"
    :checkRowKeys="checkRowKeys"
    propCode="contractNo"
  >
  </SelectTableDialog>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import BASE_API from '@/api/dataBase.js';
  import API from '@/api/purchaseSalesCenter/businessOrder';
  import { mapEnumList } from '@/common/js/enums';
  import { priceObj } from '../data';
  export default {
    props: {
      type: {
        type: String, // sales
        default: 'purchase',
      },
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      // sxp 添加 TAPD ID1001044
      departmentCode: {
        type: String,
        default: '',
      },
      // ======================
    },
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        API: API.LIST_DETAIL_ORDER,
        defaultVisible: false,
      };
    },
    computed: {
      title() {
        return this.type == 'purchase'
          ? this.$t('businessOrder.add.relatedPurchase')
          : this.$t('businessOrder.add.relatedSales');
      },
      searchColumns() {
        const beforeSearch =
          this.type === 'purchase'
            ? [
                {
                  type: 'input',
                  prop: 'contractNo',
                  name: this.$t('businessOrder.list.purchaseNo'),
                },
                {
                  prop: 'supplierNo', // 供应商
                  name: this.$t('businessOrder.list.partnerNo'),
                  type: 'searchTableSpec',
                  searchType: 'supplier',
                  isMultiple: true,
                  getSearchCode: 'partnerCode',
                },
              ]
            : [
                {
                  type: 'input',
                  prop: 'contractNo',
                  name: this.$t('businessOrder.list.salesNo'),
                },
                {
                  prop: 'customerNo', // 客户
                  name: this.$t('businessOrder.list.customer'),
                  type: 'searchTableSpec',
                  searchType: 'customer',
                  isMultiple: true,
                  getSearchCode: 'partnerCode',
                },
              ];
        return beforeSearch.concat([
          {
            type: 'startDaterangePicker',
            prop: 'contractCreateDateStart',
            name: this.$t('businessOrder.list.createTimeStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'contractCreateDateEnd',
            name: this.$t('businessOrder.list.createTimeEnd'),
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.productNo'),
            prop: 'productNo',
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
          },
          {
            type: 'input',
            prop: 'externalContractNo',
            name: this.$t('businessOrder.list.externalContractNo'),
          },
          {
            type: 'ajaxSelect',
            prop: 'contractDetailCategory',
            name: this.$t('businessOrder.list.contractType'),
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: {
              dictType:
                this.type == 'purchase'
                  ? 'purchase_contract_detail_category'
                  : 'sales_contract_detail_category',
            },
          },
          this.type == 'purchase'
            ? {
                type: 'inputRange',
                prop: ['quantityStart', 'quantityEnd'],
                name: this.$t('businessOrder.list.purchaseNumber'),
              }
            : {
                type: 'inputRange',
                prop: ['quantityStart', 'quantityEnd'],
                name: this.$t('businessOrder.list.salesNumber'),
              },
          {
            type: 'inputRange',
            prop: ['priceStart', 'priceEnd'],
            name: this.$t('businessOrder.list.contractPriceSearch'),
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.storageNo'),
            prop: 'storageNo',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
          {
            type: 'select',
            name: this.$t('businessOrder.list.priceIdentify'),
            prop: 'priceIdentity',
            options: mapEnumList(priceObj),
          },
          {
            type: 'input',
            prop: 'settleBatchNumber',
            name: this.$t('businessOrder.list.salesBatch'),
          },
        ]);
      },
      columnList() {
        const list = [
          { prop: 'contractNo', label: this.$t('salePurchase.search.contractNo'), fixed: 'left' }, // 合同号
          {
            prop: 'contractDetailNo',
            label: this.$t('businessOrder.list.contractDetailNo'),
            fixed: 'left',
          },
          this.type === 'purchase'
            ? { prop: 'supplierName', label: this.$t('businessOrder.list.partnerNo') }
            : { prop: 'customerName', label: this.$t('businessOrder.list.customer') },
          { prop: 'tradeTypeName', label: this.$t('salePurchase.search.tradeType') },
          { prop: 'businessTypeName', label: this.$t('salePurchase.search.businessType') },
          { prop: 'externalContractNo', label: this.$t('salePurchase.search.externalContractNo') },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('salePurchase.search.contractBusinessDepartment'),
          },
          { prop: 'contractCreateDate', label: this.$t('salePurchase.table.gmtCreate') },
          { prop: 'contractDetailCategoryName', label: this.$t('businessOrder.list.contractType') },
          { prop: 'productDesc', label: this.$t('salePurchase.search.product') },
          {
            prop: 'productQuantity',
            label: this.$t('businessOrder.list.contractNumber'),
            format: 'formatQuality',
          },
          {
            prop: 'businessContractUnitPrice',
            label: this.$t('salePurchase.table.businessContractUnitPrice'),
            format: 'formatPrice',
          },
          {
            prop: 'businessContractTotalAmount',
            label: this.$t('businessOrder.list.totalContractPriceTax'),
            width: 120,
            format: 'formatAmountRound',
          },
          {
            prop: 'businessChangeTotalAmount',
            label: this.$t('businessOrder.list.totalVariablePriceTax'),
            width: 120,
            format: 'formatAmountRound',
          },
          { prop: 'storageName', label: this.$t('salePurchase.search.warehouse') },
          { prop: 'priceIdentityName', label: this.$t('businessOrder.list.priceIdentify') },
          { prop: 'unitName', label: this.$t('salePurchase.table.unit') },
          { prop: 'settleBatchNumber', label: this.$t('salePurchase.table.settleBatchNumber') },
        ];
        return list;
      },
      extraData() {
        return {
          contractCategory: this.type,
          contractStatus: 'ZT03',
          isBusinessOrder: 1,
          contractBusinessDepartment: this.departmentCode,
        };
      },
    },
    methods: {
      // 弹窗确认
      confirm(selections) {
        this.$emit('confirm', selections);
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
